export default __webpack_public_path__ + "static/media/logo-blue.ceec0f81.png";